import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";

export const AdminChip = () => {
  const [standalone, setStandalone] = useState(false);
  useEffect(() => {
    setStandalone(window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true);
  }, []);
  if (!standalone) return null;
  return (
    <a href="/admin" data-testid="open-admin-chip"
      className="fixed left-4 top-20 z-[70] flex items-center gap-2 rounded-full border border-amber-500/60 bg-[#12100e]/90 px-4 py-2 text-xs font-semibold text-amber-200 shadow-[0_10px_30px_rgba(0,0,0,0.6)] backdrop-blur-md">
      <MessageCircle className="h-3.5 w-3.5" /> Messages
    </a>
  );
};
